import {Component, Input, OnInit} from '@angular/core';
import {NgModel} from '@angular/forms';
import {ValidatorMessageService} from '../../services/validator-message.service';
import {ComponentBase} from '../../entities/component-base';

@Component({
  selector: 'app-errors',
  templateUrl: './errors.component.html',
  styleUrls: ['./errors.component.css']
})
export class ErrorsComponent extends ComponentBase implements OnInit {

  @Input()
  model: NgModel;
  constructor(private _vMessage: ValidatorMessageService) { super(); }

  ngOnInit() {
  }

  get errorMessage() {
      if (this.model.errors) {
        let key = Object.keys(this.model.errors).find( k => (k == 'min' || k == 'max') && this.model.errors[k]);
        let err = this.model.errors;
        if( !key) {
          key = Object.keys(this.model.errors)[0];
          err = this.model.errors[key];
        }

      return this._vMessage.getMessage(key, err);
    }
    return null;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/errors/errors.component.ts